import { gql, useMutation } from 'urql';

export const CREATE_EVENT_ORGANIZER_MUTATION = gql`
  mutation CreateEventOrganizer($input: CreateEventOrganizer!) {
    createEventOrganizer(input: $input) {
      phone
      firstName
      lastName
      active
      createdAt
      updatedAt
      id
    }
  }
`;

export interface CreateEventOrganizerVariables {
  input: {
    eventId: number;
    phone?: string;
    firstName: string;
    lastName: string;
  };
}

export interface CreateEventOrganizerResponse {
  createEventOrganizer: {
    phone: string | null;
    firstName: string;
    lastName: string;
    createdAt: string;
    updatedAt: string;
    id: number;
  };
}

export const ADD_ORGANIZER_ERROR_MESSAGE = 'Ошибка сохранения организатора';

export const useFetchAddOrganizer = () => {
  return useMutation<CreateEventOrganizerResponse, CreateEventOrganizerVariables>(CREATE_EVENT_ORGANIZER_MUTATION);
};
